module.exports = __webpack_public_path__ + "img/banner-4.e82f1087.jpg";